// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5557":"53b5351a","7702":"7853367f"}[chunkId] + ".chunk.css";
};